import { ReactNode } from "react";
import { useData } from "vike-react/useData";

import { Post } from "#components/Post";

import type { PostData } from "./+data";

const PostLayout = ({ children }: { children: ReactNode }) => {
  const { prevMeta, meta, nextMeta } = useData<PostData>();
  return (
    <Post prevMeta={prevMeta} meta={meta} nextMeta={nextMeta}>
      {children}
    </Post>
  );
};

export default PostLayout;
